import { memo } from 'react';

function DailyPickupMarker({ backgroundColor, borderColor, size=16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
      <path
        d="M11.8899 13.2499H6.13989V7.49991H7.63989V11.7499H11.8899V13.2499Z"
        fill={borderColor}
      />
      <path
        d="M12.8899 18.0999C10.8099 18.0999 8.86989 16.9799 7.81989 15.1799L10.1599 13.8299C10.7299 14.8199 11.7499 15.4099 12.8899 15.4099C14.6299 15.4099 16.0399 13.9999 16.0399 12.2599C16.0399 10.5199 14.6299 9.10991 12.8899 9.10991C11.1499 9.10991 9.73989 10.5199 9.73989 12.2599H7.03989C7.03989 9.02991 9.65989 6.40991 12.8899 6.40991C16.1199 6.40991 18.7399 9.02991 18.7399 12.2599C18.7399 15.4899 16.1199 18.1099 12.8899 18.1099V18.0999Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(DailyPickupMarker);
